import { __decorate } from "tslib";
import { attr, FASTElement, observable } from "@microsoft/fast-element";
export class ContentIndicator extends FASTElement {
    constructor() {
        super(...arguments);
        /**
         * Whether or not the label is expanded.
         * @public
         * @remarks
         * HTML Attribute: expanded
         */
        this.expanded = false;
    }
    defaultItemsChanged() {
        if (this.$fastController.isConnected) {
            this.shouldanimate = this.defaultItems.length > 0;
        }
    }
}
__decorate([
    attr({ mode: "boolean" })
], ContentIndicator.prototype, "expanded", void 0);
__decorate([
    observable
], ContentIndicator.prototype, "defaultItems", void 0);
__decorate([
    attr({ mode: "boolean", attribute: "animate" })
], ContentIndicator.prototype, "shouldanimate", void 0);
